import { DocumentType } from 'models/documents/DocumentType';
import { QuoteWorkspaceType } from 'state/workspaces/model';

import { DocumentButton } from './DocumentButton';

interface Props {
  documents: DocumentType[];
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export function DocumentButtons({ documents, tabId, workspaceType }: Props) {
  return documents.map(doc => (
    <DocumentButton documentType={doc} tabId={tabId} workspaceType={workspaceType} key={doc} />
  ));
}
